export const NOTIF_TYPES = {
  SATHI_MIGRATION_COMPLETED: 'sathi_migration_completed',
  SATHI_MIGRATION_INTERRUPTED: 'sathi_migration_interrupted',
  PULSE_AD_SHARE_PAYOUT_SUCCEEDED: 'pulseAdSharePayoutSucceeded',
  PULSE_AD_SHARE_PAYOUT_INSUFFICIENT_BALANCE_FAILED:
    'pulseAdSharePayoutInsufficientBalanceFailed',
  PULSE_AD_SHARE_PAYOUT_FAILED: 'pulseAdSharePayoutFailed',
  PAYOUT_METHOD_CHANGED: 'payoutMethodChanged',
} as const;
